// src/hooks/useRefund.js
import { useCallback } from 'react';
import config from '../config';
import { toReadableTotal } from '../utils/orderUtils';

const host = config.backendUrl;

export default function useRefund({ order, authToken }) {
  const refund = useCallback(
    (amountOverride = null) => {
      if (!order || !order.id || !order.cost?.total) return;

      let amount = amountOverride;

      if (!amount) {
        const input = prompt(
          "Enter refund amount. Don't include the $ sign. For example, enter 10.00 for $10.00."
        );
        amount = parseFloat(input) * 100;
      }

      if (amount > order.cost.total) {
        alert("Amount can't be greater than the order cost");
        return;
      }

      if (amount <= 0 || isNaN(amount)) {
        alert('Amount must be a valid number greater than 0');
        return;
      }

      const reason = prompt('Enter a reason for the refund (optional):', 'No reason provided');
      if (reason === null) return; // User cancelled

      if (reason.length > 500) {
        alert('Reason is too long. Please keep it under 500 characters.');
        return;
      }

      if (!window.confirm(`Are you sure you want to initiate a ${
        amount === order.cost.total ? 'FULL' : 'PARTIAL'
      } refund of $${toReadableTotal(amount)}?`)) {
        return;
      }

      fetch(`${host}/api/admin/refund/${order.id}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({ amount, reason }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === 'succeeded') {
             
            alert('Refund successful');
          } else {
            alert('Refund failed');
          }
        })
        .catch((err) => {
          console.error('Refund request failed:', err);
          alert('Refund failed');
        });
    },
    [order, authToken]
  );

  return { refund };
}